import { HttpInterceptorFn } from '@angular/common/http';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // Recuperamos el token que guardamos en el login
  const token = localStorage.getItem('auth_token');

  // Si el token existe, clonamos la petición y le añadimos la cabecera Authorization
  if (token) {
    const clonedReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}` // Asegúrate de si tu API usa 'Bearer ' o solo el token directo
      }
    });
    return next(clonedReq);
  }

  // Si no hay token, la petición sigue su curso normal
  return next(req);
};